export default "__VITE_ASSET__ctnmt5uq__"